import { createReducer, on } from '@ngrx/store';
import * as actions from './products.actions';
import {
  SubscriptionProductsState,
  initialSubscriptionProductsState,
  subscriptionProductsEntityAdapter,
} from './products.state';

export const productsReducer = createReducer(
  initialSubscriptionProductsState,
  on(
    actions.loadProductsSuccess,
    (_state, { products }): SubscriptionProductsState => {
      const newState = subscriptionProductsEntityAdapter.setAll(
        products,
        initialSubscriptionProductsState
      );
      return {
        ...newState,
        loadStatus: 'success',
      };
    }
  ),
  on(
    actions.loadProductsError,
    (_state, { error }): SubscriptionProductsState => ({
      ...initialSubscriptionProductsState,
      loadStatus: 'error',
      error,
    })
  )
);
